module.exports = __webpack_public_path__ + "img/pytrace-window.42183bf1.png";